/* eslint-disable no-unused-vars */

import React, { useRef, useState, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import classNames from "classnames"
import BackgroundImage from "gatsby-background-image"
import Button from "components/Button"
import { useLocale } from "context/locale"
import StyledStrategyAnimation from "./styles"

let interval

const StrategyAnimation = () => {
  const ref = useRef(null)
  const [active, setActive] = useState(true)
  const [slide, setSlide] = useState(3)
  const { t } = useLocale()
  const data = useStaticQuery(
    graphql`
      query {
        create_fair_left: file(
          relativePath: { eq: "strategy_animation/left/create_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        create_fair_right: file(
          relativePath: { eq: "strategy_animation/right/create_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        think_fair_left: file(
          relativePath: { eq: "strategy_animation/left/think_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        think_fair_right: file(
          relativePath: { eq: "strategy_animation/right/think_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        live_fair_left: file(
          relativePath: { eq: "strategy_animation/left/live_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        live_fair_right: file(
          relativePath: { eq: "strategy_animation/right/live_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        act_fair_left: file(
          relativePath: { eq: "strategy_animation/left/act_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        act_fair_right: file(
          relativePath: { eq: "strategy_animation/right/act_fair.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        circularity: file(
          relativePath: { eq: "refresh/BELKA_CIRCULARITY.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        planet: file(relativePath: { eq: "refresh/BELKA_PLANET.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        people: file(relativePath: { eq: "refresh/BELKA_PEOPLE.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        product: file(relativePath: { eq: "refresh/BELKA_PRODUCT.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  const runAnimation = () => {
    interval = setInterval(() => {
      setSlide(slide => (slide + 1 > 3 ? 0 : slide + 1))
    }, 2000)
  }

  useEffect(() => {
    return () => {
      clearInterval(interval)
    }
  }, [])
  useEffect(() => {
    if (active) {
      clearInterval(interval)
    } else {
      runAnimation()
    }
  }, [active])

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (ref.current && !ref.current.contains(event.target) && active) {
  //       setActive(false)
  //     }
  //   }
  //   document.addEventListener("mousedown", handleClickOutside)
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside)
  //   }
  // }, [ref, active])

  return (
    <StyledStrategyAnimation
      slide={slide}
      className={classNames({ active })}
      // onClick={() => {
      //   setActive(true)
      // }}
      // onTouchStart={() => {
      //   setActive(true)
      // }}
      ref={ref}
    >
      <div className="animation-slider left">
        <div
          className="animation-column"
          style={
            active
              ? {}
              : {
                  transform: [`translateY(${slide * 25}%)`],
                }
          }
        >
          <BackgroundImage
            className="animation-slide act"
            fluid={data.circularity.childImageSharp.fluid}
            onClick={() => setSlide(3)}
          >
            <div className="animation-slide__inner">
              <p className="bolder animation-slide__animate-text">
                #{t("circularity")}
              </p>
              <div className="animation-slide__content">
                <p className="bolder title">#{t("circularity")}</p>
                <p className="desc">
                  {t(
                    "We are making changes in our operations regarding both processes and workplaces. We emphasize operating with respecting people and the environment."
                  )}
                </p>
                <Button
                  text={t("more")}
                  as="link"
                  href={t("strategy_link")}
                  state={{ tab: "work_space" }}
                />
              </div>
            </div>
          </BackgroundImage>
          <BackgroundImage
            className="animation-slide live"
            fluid={data.people.childImageSharp.fluid}
            onClick={() => setSlide(2)}
          >
            <div className="animation-slide__inner">
              <p className="bolder animation-slide__animate-text">
                #{t("people")}
              </p>
              <div className="animation-slide__content">
                <p className="bolder title">#{t("people")}</p>
                <p className="desc">
                  {t(
                    "We change our thinking through education. We are learning how how our personal attitudes affect the planet. We give our employees the knowledge and tools to make a difference."
                  )}
                </p>
                <Button
                  text={t("more")}
                  as="link"
                  href={t("strategy_link")}
                  state={{ tab: "philosophy" }}
                />
              </div>
            </div>
          </BackgroundImage>
          <BackgroundImage
            className="animation-slide think"
            fluid={data.planet.childImageSharp.fluid}
            onClick={() => setSlide(1)}
          >
            <div className="animation-slide__inner">
              <p className="bolder animation-slide__animate-text">
                #{t("planet")}
              </p>
              <div className="animation-slide__content">
                <p className="bolder title">#{t("planet")}</p>
                <p className="desc">
                  {t(
                    "We care about our environment by involving our environmental projects and partnerships with individuals and and organizations that benefit the planet."
                  )}
                </p>
                <Button
                  text={t("more")}
                  as="link"
                  href={t("strategy_link")}
                  state={{ tab: "environment" }}
                />
              </div>
            </div>
          </BackgroundImage>

          <BackgroundImage
            className="animation-slide create"
            fluid={data.product.childImageSharp.fluid}
            onClick={() => setSlide(0)}
          >
            <div className="animation-slide__inner">
              <p className="bolder animation-slide__animate-text">
                #{t("product")}
              </p>
              <div className="animation-slide__content">
                <p className="bolder title">#{t("product")}</p>
                <p className="desc">
                  {t(
                    "We are making changes in the way we create. We are gradually changing our products to be more sustainable and extend the life of existing clothings."
                  )}
                </p>
                <Button
                  text={t("more")}
                  as="link"
                  href={t("strategy_link")}
                  state={{ tab: "product" }}
                />
              </div>
            </div>
          </BackgroundImage>
        </div>
      </div>
      <div className="animation-slider right">
        <div
          className="animation-column"
          style={{
            transform: [`translateY(${slide * -25}%)`],
          }}
        >
          <BackgroundImage
            className="animation-slide"
            fluid={data.create_fair_right.childImageSharp.fluid}
          >
            <div className="animation-slide__inner" />
          </BackgroundImage>
          <BackgroundImage
            className="animation-slide"
            fluid={data.think_fair_right.childImageSharp.fluid}
          >
            <div className="animation-slide__inner" />
          </BackgroundImage>

          <BackgroundImage
            className="animation-slide"
            fluid={data.live_fair_right.childImageSharp.fluid}
          >
            <div className="animation-slide__inner" />
          </BackgroundImage>
          <BackgroundImage
            className="animation-slide"
            fluid={data.act_fair_right.childImageSharp.fluid}
          >
            <div className="animation-slide__inner" />
          </BackgroundImage>
        </div>
      </div>
      <p className="animation-right-text bolder">_fair</p>
      <Button
        text={t("check")}
        as="button"
        className="animation-button-placeholder"
        // onClick={() => {
        //   setActive(true)
        // }}
      >
        <span className="bolder">{t("more about the strategy")}</span>
      </Button>
    </StyledStrategyAnimation>
  )
}

export default StrategyAnimation
